import type { RuleReferenceId } from './clinical/references'
import { allRuleReferenceIds, referenceSources, ruleReferences } from './clinical/references'

export function RuleReferences({ ids, label = 'Riferimenti' }: { ids: RuleReferenceId[]; label?: string }) {
  const rules = ids.map((id) => ruleReferences[id])
  const methodologyOnly = rules.every((rule) => rule.sourceIds.every((sourceId) => referenceSources[sourceId].kind === 'methodology'))

  return (
    <details className={`rule-references ${methodologyOnly ? 'methodology' : ''}`}>
      <summary>{methodologyOnly ? 'Metodologia e audit' : label}</summary>
      <div className="rule-reference-list">
        {rules.map((rule) => (
          <article key={rule.id} className="rule-reference-item">
            <strong>{rule.label}</strong>
            <p>{rule.description}</p>
            <div className="rule-reference-sources">
              {rule.sourceIds.map((sourceId) => {
                const source = referenceSources[sourceId]
                return source.url ? (
                  <a key={source.id} href={source.url} target="_blank" rel="noreferrer noopener">{source.shortTitle}</a>
                ) : (
                  <span key={source.id}>{source.shortTitle}</span>
                )
              })}
            </div>
            <small>Regola v{rule.implementationVersion} · verificata {rule.verifiedOn.split('-').reverse().join('/')}</small>
          </article>
        ))}
      </div>
    </details>
  )
}

export function SourcesMethodologyPanel() {
  const clinicalSources = Object.values(referenceSources).filter((source) => source.kind === 'clinical')
  const methodologySources = Object.values(referenceSources).filter((source) => source.kind === 'methodology')

  return (
    <section className="panel sources-methodology-panel" id="fonti-metodologia">
      <div className="sources-heading">
        <div>
          <p className="step">Trasparenza del motore · v0.4.2</p>
          <h2>Fonti e metodologia</h2>
          <p>Ogni regola clinica è collegata alla fonte primaria utilizzata. Le scelte di audit e architettura sono indicate separatamente come metodologia interna.</p>
        </div>
        <span className="source-registry-badge">{allRuleReferenceIds.length} REGOLE MAPPATE</span>
      </div>

      <div className="source-registry-grid">
        {clinicalSources.map((source) => (
          <article key={source.id} className="source-card clinical-source">
            <span>Fonte clinica</span>
            <strong>{source.shortTitle}</strong>
            <p>{source.citation}</p>
            {source.url && <a href={source.url} target="_blank" rel="noreferrer noopener">DOI {source.doi}</a>}
          </article>
        ))}
        {methodologySources.map((source) => (
          <article key={source.id} className="source-card methodology-source">
            <span>Metodologia interna</span>
            <strong>{source.shortTitle}</strong>
            <p>{source.citation}</p>
          </article>
        ))}
      </div>

      <details className="rule-map-details">
        <summary>Mappa regole → fonti</summary>
        <div className="rule-map-grid">
          {allRuleReferenceIds.map((id) => {
            const rule = ruleReferences[id]
            return (
              <div key={id} className="rule-map-row">
                <strong>{rule.label}</strong>
                <span>{rule.sourceIds.map((sourceId) => referenceSources[sourceId].shortTitle).join(' · ')}</span>
                <small>v{rule.implementationVersion} · {rule.verifiedOn}</small>
              </div>
            )
          })}
        </div>
      </details>
    </section>
  )
}
